//@flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { type TooltipProps } from '../../../..';
// import { type Currency } from '../../../../utilities/types';
import {
  toggleShowSummary,
  toggleShowDetailedSummary,
  showTooltip
} from './reducer/views';
import IconWithText from '../../../../components/IconWithText';
import Statistics from '../../../../components/Statistics';
import { formatCurrency } from '../../../../utilities/numberFormatting';
import { dig } from '../../../../utilities/misc';
// import { getPartnerCurrency } from '../../../../utilities/selectors';

export type ProcessingSums = Array<{
  transaction_amount: number,
  transaction_fee: number,
  revenue_share: number,
  currency: string
}>;
type Props = {
  processingSums: ProcessingSums,
  totalFeesUsd: string,
  // partnerCurrency: Currency,
  totalProcessingVolUsd: string,
  toggleShowSummary: () => void,
  toggleShowDetailedSummary: () => void,
  showSummary: string,
  showDetailedSummary: boolean,
  ...$Exact<TooltipProps>
};

class TableStatistics extends Component<Props> {
  processingVol = () => (
    <IconWithText
      message={
        'This is an estimated amount in USD based on the exchange rate at the time of purchase.'
      }
      label={formatCurrency(
        Number(this.props.totalProcessingVolUsd),
        this.props.currencies['USD']
      )}
      activeTooltip={this.props.activeTooltip}
      tooltipName={'merchants/PROCESSING_VOLUME_TOOLTIP'}
      showTooltip={this.props.showTooltip}
      smallIcon
    />
  );

  totalFees = () => (
    <IconWithText
      message={
        'This is an estimated amount in USD based on the exchange rate at the time of purchase.'
      }
      label={formatCurrency(
        Number(this.props.totalFeesUsd),
        this.props.currencies['USD']
      )}
      activeTooltip={this.props.activeTooltip}
      tooltipName={'merchants/TRANSACTION_FEES_TOOLTIP'}
      showTooltip={this.props.showTooltip}
      smallIcon
    />
  );

  render() {
    return (
      <Statistics
        storageDetailOptions={{
          handler: this.props.toggleShowDetailedSummary,
          slice: this.props.showDetailedSummary,
          value: 'merchants/statisticsDetailToggled'
        }}
        storageTotalOptions={{
          handler: this.props.toggleShowSummary,
          slice: this.props.showSummary,
          value: 'merchants/statisticsTotalToggled'
        }}
        tableHeaderOptions={{
          desktop: [
            {
              lg: 'Total Direct Merchants',
              sm: 'Tot. Direct Merchants',
              smCustomWidth: '170px',
              lgCustomWidth: '181px'
            },
            {
              lg: 'Total Processing Vol.',
              sm: 'Tot. Processing Vol.',
              right: true
            },
            { lg: 'Total Trans. Fees', sm: 'Tot Trans. Fees', right: true },
            { lg: 'Total Comm. Earned', sm: 'Tot Comm. Earned', right: true }
          ],
          device: {
            row1: [
              {
                lg: 'Total Direct Merchants',
                sm: 'Tot. Direct Merchants',
                tooltip: true,
                right: true
              }
            ],
            row2: [
              { lg: 'Total Processing Vol.', sm: 'Tot. Processing Vol.' },
              { lg: 'Tot. Fees', right: true },
              { lg: 'Total Comm. Earned', sm: 'Tot. Comm. Earned', right: true }
            ]
          }
        }}
        tableRowOptions={{
          desktop: {
            breakdown: {
              data: this.props.processingSums,
              columns: [
                {
                  value: this.props.totalUsers,
                  showOnce: true,
                  right: true,
                  bold: true,
                  customPadding: '18px'
                },
                { value: 'transaction_amount', right: true },
                { value: 'transaction_fee', right: true },
                { value: 'revenue_share', right: true }
              ]
            },
            total: {
              toggled: [
                { value: 'TOTAL USD', bold: true },
                { value: this.processingVol(), right: true, bold: true },
                { value: this.totalFees(), right: true, bold: true },
                { value: 'toggle', right: true, bold: true }
              ],
              untoggled: [
                {
                  value: this.props.totalUsers,
                  right: true,
                  bold: true,
                  customPadding: '18px'
                },
                { value: this.processingVol(), right: true },
                { value: this.totalFees(), right: true },
                { value: 'toggle', right: true }
              ]
            }
          },
          device: {
            row1: [
              {
                value: this.props.totalUsers,
                right: true,
                bold: true
              }
            ],
            row2: {
              breakdown: {
                data: this.props.processingSums,
                columns: [
                  { value: 'transaction_amount' },
                  { value: 'transaction_fee' },
                  { value: 'revenue_share' }
                ]
              },
              total: [
                { value: this.processingVol() },
                { value: this.totalFees() },
                { value: 'toggle' }
              ]
            }
          }
        }}
      />
    );
  }
}

const mapStateToProps = state => ({
  processingSums: dig(
    state.merchants.directMerchants.index.directMerchants,
    'processing_sums'
  ),
  totalFeesUsd: dig(
    state.merchants.directMerchants.index.directMerchants,
    'total_fees_usd'
  ),
  totalProcessingVolUsd: dig(
    state.merchants.directMerchants.index.directMerchants,
    'total_processing_vol_usd'
  ),
  totalUsers: dig(
    state.merchants.directMerchants.index.directMerchants,
    'total_users'
  ),
  activeTooltip: state.merchants.directMerchants.index.views.activeTooltip,
  showSummary: state.merchants.directMerchants.index.views.showSummary,
  showDetailedSummary:
    state.merchants.directMerchants.index.views.showDetailedSummary,
  // partnerCurrency: getPartnerCurrency(state),
  currencies: state.global.currencies
});

const mapDispatchToProps = {
  showTooltip,
  toggleShowSummary,
  toggleShowDetailedSummary
};

export default connect(mapStateToProps, mapDispatchToProps)(TableStatistics);
